if (!customElements.get('image-with-text-tabs')) {
    customElements.define('image-with-text-tabs', class ImageWithTextTabs extends HTMLElement {
        constructor() {
            super();

            this.elements = {
                tabList: this.querySelector('.image-with-text__tab-list ul'),
                tabs: this.querySelectorAll('.image-with-text__tab'),
                icon: document.querySelector('.image-with-text__icon--' + this.dataset.section),
                image: document.querySelector('.image-with-text__image--' + this.dataset.section),
            };

            if (this.elements.tabs && this.elements.tabs.length > 0) {
                for (let i = 0; i < this.elements.tabs.length; i++) {
                    const tabButton = document.createElement('li');
                    tabButton.innerHTML = '<a href="#" data-index="' + i + '" class="image-with-text__tab-button link link--text">' + this.elements.tabs[i].dataset.title + '</a>';
                    this.elements.tabList.appendChild(tabButton);
                }

                this.elements.tabButtons = this.querySelectorAll('.image-with-text__tab-button');
                this.elements.tabButtons.forEach((button) =>
                    button.addEventListener('click', this.changeActiveTab.bind(this))
                );

                this.setActiveTab(0);
                this.setHeight();

                window.addEventListener('resize', this.setHeight.bind(this));
                if (screen.orientation) { // Property doesn't exist on screen in IE11   
                    screen.orientation.addEventListener('change', this.setHeight.bind(this));
                }
            }
        }

        setHeight() {
            let height = 0;
            for (let i = 0; i < this.elements.tabs.length; i++) {
                if (height < this.elements.tabs[i].offsetHeight) {
                    height = this.elements.tabs[i].offsetHeight;
                }
            }

            if (window.innerWidth < 990) {
                this.style.height = (height + 90) + 'px';
            } else {
                this.style.height = height + 'px';
            }

            this.classList.add('image-with-text-tabs--active');
        }

        setActiveTab(index) {
            this.elements.tabButtons[index].classList.add('image-with-text__tab-button--active');
            this.elements.tabs[index].classList.add('image-with-text__tab--active');

            if (this.elements.icon) {
                this.elements.icon.src = this.elements.tabs[index].dataset.icon;
            }

            if (this.elements.image) {
                this.elements.image.src = this.elements.tabs[index].dataset.image;
            }
        }

        clearActiveTabs() {
            for (let i = 0; i < this.elements.tabs.length; i++) {
                this.elements.tabButtons[i].classList.remove('image-with-text__tab-button--active');
                this.elements.tabs[i].classList.remove('image-with-text__tab--active');
            }
        }

        changeActiveTab(event) {
            event.preventDefault();

            this.clearActiveTabs();
            this.setActiveTab(event.target.dataset.index);
        }
    });
}
